import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-release-dialog',
  templateUrl: './release-dialog.component.html',
  styleUrls: ['./release-dialog.component.scss']
})
export class ReleaseDialogComponent implements OnInit {

  public reason:string = "";

  public holdType: 'single'|'merchant'|'terminal';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit() {
  }


  public close() {
    this.modal.close(null);
  }

  public closeAndRelease() {
    this.modal.close({
      holdType: this.holdType,
      reason: this.reason
    });
  }

}
